import { render } from "./Created.vue?vue&type=template&id=947d611a&scoped=true"
import script from "./Created.vue?vue&type=script&lang=js"
export * from "./Created.vue?vue&type=script&lang=js"

import "./Created.vue?vue&type=style&index=0&id=947d611a&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947d611a"]])

export default __exports__